import { render } from "./UIButton.vue?vue&type=template&id=7a77ff84&scoped=true&ts=true"
import script from "./UIButton.vue?vue&type=script&lang=ts"
export * from "./UIButton.vue?vue&type=script&lang=ts"

import "./UIButton.vue?vue&type=style&index=0&id=7a77ff84&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a77ff84"]])

export default __exports__